module.exports = __webpack_public_path__ + "static/media/2DGACM16.68cebe49.jpg";